// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2gRUC","additionalInfo":"AgreementModal_additionalInfo__S2Eju"};